/**
 * Load more.
 *
 * Calls the same path the infinite scroll observer uses, so pages are fetched
 * and appended by the existing component rather than duplicating that logic
 * here. The observer is switched off in this mode, so nothing advances until
 * the customer asks.
 */

function listFor(button) {
  return button.closest('results-list, paginated-list, [section-id]');
}

async function loadMore(button) {
  const list = listFor(button);
  if (!list || typeof list.loadMore !== 'function') return;

  button.setAttribute('aria-busy', 'true');

  try {
    await list.loadMore();
  } finally {
    button.removeAttribute('aria-busy');

    // The component knows whether a further page exists; hide the button when
    // it does not rather than leaving a control that does nothing.
    // hasNextPage only checks that a URL can be built, and one always can, so
    // it never came back false. The grid carries the real total.
    const grid = list.querySelector('[data-last-page]');
    const lastPage = Number(grid?.dataset.lastPage) || 0;

    const cards = list.querySelectorAll('[data-page]');
    const loadedPage = cards.length ? Number(cards[cards.length - 1].dataset.page) || 0 : 0;

    if (lastPage && loadedPage >= lastPage) button.setAttribute('hidden', '');

    // Keep the count in step as pages load.
    const counter = list.querySelector('[data-load-more-count]');
    const shown = counter?.querySelector('[data-load-more-shown]');
    if (counter && shown) {
      const pageSize = Number(counter.dataset.pageSize) || 0;
      const total = Number(counter.dataset.total) || 0;
      const visible = Math.min(loadedPage * pageSize, total);
      if (visible > 0) shown.textContent = String(visible);
      if (total && visible >= total) counter.setAttribute('hidden', '');
    }
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-load-more]');
  if (!button) return;

  event.preventDefault();
  loadMore(button);
});
